import { RootState } from 'store/rootTypes';

export const TransactionSelector = (state: RootState) => state.Transaction;
